import React, { useState } from 'react';
import './App.css';

/**
 * PropertySelector - Dropdown to select and manage properties
 */
const PropertySelector = ({
    properties,
    currentProperty,
    onPropertyChange,
    onAddProperty,
    // subscription, // Removed for free launch
    // onUpgradeClick // Removed for free launch
}) => {
    const [isOpen, setIsOpen] = useState(false);
    // FREE LAUNCH: All users can add unlimited properties
    // const isPremium = subscription?.is_premium || subscription?.plan === 'premium';
    // const canAddProperty = isPremium || (properties?.length || 0) < 1;

    const handleAddClick = () => {
        // FREE LAUNCH: No property limits
        onAddProperty();
        // PREMIUM VERSION (commented out):
        // if (!canAddProperty) {
        //     onUpgradeClick();
        // } else {
        //     onAddProperty();
        // }
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            {/* Current Property Display */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 16px',
                    backgroundColor: 'white',
                    border: '2px solid #667eea',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    fontWeight: '500',
                    color: '#1a1a2e',
                    minWidth: '200px',
                    justifyContent: 'space-between'
                }}
            >
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    🏠 {currentProperty?.name || 'Select Property'}
                </span>
                <span style={{ fontSize: '0.8rem' }}>▼</span>
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <>
                    {/* Backdrop */}
                    <div
                        onClick={() => setIsOpen(false)}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 999
                        }}
                    />

                    {/* Menu */}
                    <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        marginTop: '8px',
                        backgroundColor: 'white',
                        border: '1px solid #e5e5e5',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        minWidth: '250px',
                        maxHeight: '400px',
                        overflow: 'auto',
                        zIndex: 1000
                    }}>
                        {/* Property List */}
                        <div style={{ padding: '8px 0' }}>
                            {properties && properties.length > 0 ? (
                                properties.map(property => (
                                    <div
                                        key={property.id}
                                        onClick={() => {
                                            console.log('🏠 PropertySelector: Property clicked:', property.name, 'ID:', property.id);
                                            onPropertyChange(property);
                                            console.log('🏠 PropertySelector: onPropertyChange called');
                                            setIsOpen(false);
                                        }}
                                        style={{
                                            padding: '12px 16px',
                                            cursor: 'pointer',
                                            backgroundColor: currentProperty?.id === property.id ? '#f0f0ff' : 'white',
                                            borderLeft: currentProperty?.id === property.id ? '3px solid #667eea' : '3px solid transparent',
                                            transition: 'background-color 0.2s'
                                        }}
                                        onMouseOver={(e) => {
                                            if (currentProperty?.id !== property.id) {
                                                e.currentTarget.style.backgroundColor = '#fafafa';
                                            }
                                        }}
                                        onMouseOut={(e) => {
                                            if (currentProperty?.id !== property.id) {
                                                e.currentTarget.style.backgroundColor = 'white';
                                            }
                                        }}
                                    >
                                        <div style={{ fontWeight: '500', color: '#1a1a2e' }}>
                                            {property.name}
                                        </div>
                                        <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '2px' }}>
                                            {property.city}, {property.state}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div style={{ padding: '16px', textAlign: 'center', color: '#666' }}>
                                    No properties yet
                                </div>
                            )}
                        </div>

                        {/* Divider */}
                        <div style={{ height: '1px', backgroundColor: '#e5e5e5', margin: '8px 0' }} />

                        {/* Add Property Button */}
                        <div style={{ padding: '8px' }}>
                            <button
                                onClick={handleAddClick}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    backgroundColor: '#667eea', // Always enabled for free launch
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    fontSize: '0.95rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '6px'
                                }}
                            >
                                ➕ Add Property
                                {/* PREMIUM VERSION (commented out):
                                {canAddProperty ? (
                                    <>➕ Add Property</>
                                ) : (
                                    <>🔒 Upgrade for More Properties</>
                                )}
                                */}
                            </button>
                        </div>

                        {/* Property Count */}
                        <div style={{
                            padding: '8px 16px',
                            fontSize: '0.8rem',
                            color: '#666',
                            textAlign: 'center',
                            borderTop: '1px solid #f0f0f0'
                        }}>
                            {properties?.length || 0} properties
                            {/* PREMIUM VERSION: {properties?.length || 0} {isPremium ? 'properties' : '/ 1 property'} */}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default PropertySelector;
